import ConfirmExtraction from './ConfirmExtraction';

export default ConfirmExtraction;
